

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { WorkflowDefineFormComponent } from './workflowdefine-form/workflowdefine-form.component';
import { WorkflowDefineComponent } from './workflowdefine.component';
import { WorkflowDefineRoutes } from './workflowdefine.routing';

export function declaration() {
    return [WorkflowDefineComponent, WorkflowDefineFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class WorkflowDefineModule {
}

@NgModule({
    imports: [WorkflowDefineModule, WorkflowDefineRoutes],
    exports: [WorkflowDefineModule]
})
export class WorkflowDefineWithRouteModule {
}
